import Emitter from '../util/emitter';

function loadFormsScript(scriptURL) {
	return new Promise((resolve, reject) => {
		const mktoScript = document.createElement('script');

		mktoScript.setAttribute('defer', 'defer');
		mktoScript.setAttribute('src', scriptURL);

		mktoScript.addEventListener('load', () => {
			resolve();
		});

		mktoScript.addEventListener('error', () => {
			reject();
		});

		document.body.appendChild(mktoScript);
	});
}

function removeInlineFormStyling(formEl) {
	// remove "style" attribute from the form element
	formEl.removeAttribute('style');

	// remove "style" element children of the form element
	const styleEls = formEl.querySelectorAll('style');

	for (let i = 0; i < styleEls.length; i++) {
		styleEls[i].remove();
	}

	// loop through all child elements of the form with
	// "style" attributes and remove the attribute
	const formEls = formEl.querySelectorAll('[style]');

	for (let i = 0; i < formEls.length; i++) {
		formEls[i].removeAttribute('style');
	}
}

function removeAddedCSSlinks() {
	const linkEls = document.querySelectorAll('head link');

	for (let i = 0; i < linkEls.length; i++) {
		const href = linkEls[i].getAttribute('href').toLowerCase();

		if (href.indexOf('marketo.com') !== -1 && href.indexOf('.css') !== -1) {
			linkEls[i].remove();
		}
	}
}

function resizeCheckboxRows(formEl) {
	const hiddenEls = formEl.querySelectorAll('.mktoFormRow INPUT[type="hidden"]');
	[].forEach.call(hiddenEls, function (el) {
		el.parentNode.style.cssText =
			'height: 0px !important; width: 0px !important; padding-left: 0px !important;';
	});

	const nonHiddenCheckboxes = formEl.querySelectorAll('.mktoFormRow INPUT[type="checkbox"]');
	if (nonHiddenCheckboxes.length > 0) {
		for (var i = 0; i < nonHiddenCheckboxes.length; i++) {
			var element = nonHiddenCheckboxes[i];
			const checkboxRow = element.closest('.mktoFormRow');
			if (checkboxRow) {
				checkboxRow.classList.add('checkbox-row');

				// older forms might have &nspc; which screws up the rendering
				const lbls = checkboxRow.querySelectorAll('.mktoLabel');
				if (lbls.length) {
					for (var x = 0; x < lbls.length; x++) {
						var lbl = lbls[x];
						lbl.innerHTML = lbl.innerHTML.replaceAll('&nbsp;', ' ');
					}
				}
			}
		}
	}
}

function customStyleAttributes() {
	jQuery(function ($) {
		const placeholderFields = $('.mktoPlaceholder');
		placeholderFields.parent().addClass('hide').addClass('conditional-fields');
		const selects = $('select');
		// Partner Form
		const partnerCheckboxes = $('#LblbecomeaPartnerReason');
		partnerCheckboxes.parents('.mktoFormRow').addClass('partner-checkbox-row');
		const rows = $('.mktoFormRow');

		const observerTargets = document.querySelectorAll('form .conditional-fields');

		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				const nodes = document.querySelectorAll('form .conditional-fields');

				nodes.forEach((node) => {
					node.querySelectorAll('select').forEach((select) => {
						console.log('changin', select);
						select.removeAttribute('style');
					});

					node.querySelectorAll('.mktoOffset').forEach((offset) => {
						offset.classList.add('hide');
					});
				});
			});
		});

		console.log('DATA', observerTargets);

		observerTargets.forEach((target) => {
			observer.observe(target, {
				attributes: false,
				childList: true,
				subtree: true
			});
		});

		for (let i = 0; i < rows.length; i++) {
			const element = rows[i];

			// Check if the element contains an element with class '.mktoHtmlText'
			if (element.querySelector('.mktoHtmlText')) {
				// Add a class to the outer element
				element.classList.add('hasHtml'); // Replace 'outerClass' with the desired class name
			}
		}

		selects.on('change', function () {
			$('.mktoFormRow').removeClass('hide');
			placeholderFields.parent().addClass('hide');

			const checkboxes = $(':checkbox');
			const checkboxRows = checkboxes.parents('.mktoFormRow');
			checkboxRows.addClass('checkbox-row');

			for (let i = 0; i < checkboxRows.length; i++) {
				const element = checkboxRows[i];

				const labelFields = element.querySelectorAll('.mktoLabel');
				const checkboxLists = element.querySelectorAll('.mktoCheckboxList');

				checkboxLists.forEach((list) => {
					list.removeAttribute('style');
				});

				labelFields.forEach((label) => {
					label.removeAttribute('style');
				});

				// Check if the element contains an element with class '.mktoHtmlText'
				if (element.querySelector('.mktoHtmlText')) {
					// Add a class to the outer element
					element.classList.add('hasHtml'); // Replace 'outerClass' with the desired class name
				}
			}
		});

		const subscriptionCheckbox = $('#subscriptionBlog');

		subscriptionCheckbox.on('change', function () {
			setTimeout(function () {
				$('label#LblblogCadence').removeAttr('style');
				$('select#blogCadence').parent().closest('.mktoFormRow').removeClass('hide');
			}, 100);
		});

		const partnerInterestedField = $('#LblbecomeaPartnerNotes');
		partnerInterestedField.parents('.mktoFormRow').addClass('full-width-row');
		const partnerStaffingCustomersField = $('#LblbecomeaPartnerStaffingCustomers');
		partnerStaffingCustomersField.parents('.mktoFormRow').addClass('full-width-row');
	});
}

// Helper function to get a meaningful identifier for a field
function getFieldIdentifier(input) {
	// Try to get the label text first
	const labelIdArray = input.getAttribute('aria-labelledby');
	const labelId = labelIdArray.split(' ')[0];

	if (labelId) {
		const label = document.getElementById(labelId);

		if (label) {
			// Remove the asterisk and clean up the label text
			return label.textContent
				.replace('*', '')
				.trim()
				.toLowerCase()
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '');
		}
	}

	// Fall back to input name or id
	const name = input.getAttribute('name') || input.getAttribute('id');
	if (name) {
		return name
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-+|-+$/g, '');
	}

	return null;
}

function assignWidthClasses(formEl) {
	const inputs = formEl.querySelectorAll(
		'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], input[type="radio"], input[type="checkbox"], select, textarea, input[type="range"], input[type="date"], input[type="url"]'
	);
	const processedRows = new Set();

	// Map of input types to their corresponding row classes
	const typeToClassMap = {
		radio: 'radio-row',
		select: 'select-row',
		textarea: 'textarea-row',
		range: 'range-row',
		date: 'date-row',
		text: 'text-row',
		email: 'text-row',
		tel: 'text-row',
		url: 'text-row',
		number: 'text-row'
	};

	// Map of special case selectors to their input types
	const specialCaseMap = {
		'.mktoCheckboxList': 'checkbox',
		'.mktoRadioList': 'radio',
		'.mktoRangeField': 'range'
	};

	inputs.forEach((input) => {
		const formRow = input.closest('.mktoFormRow');
		if (!formRow || processedRows.has(formRow)) return;

		// Assign width class based on inline style, capping at 100
		const style = input.getAttribute('style');
		let widthClass = 'width-100';
		if (style) {
			const widthMatch = style.match(/width:\s*(\d+)px/);
			if (widthMatch) {
				let widthValue = parseInt(widthMatch[1], 10);
				if (widthValue > 100) {
					widthValue = 100; // Cap width at 100
				}
				widthClass = `width-${widthValue}`;
			}
		}
		formRow.classList.add(widthClass);

		// Add required class if input is required
		if (input.hasAttribute('aria-required') && input.getAttribute('aria-required') === 'true') {
			formRow.classList.add('required');
		}

		// Determine input type for class assignment using switch
		let inputType;
		switch (input.tagName) {
			case 'SELECT':
				inputType = 'select';
				break;
			case 'TEXTAREA':
				inputType = 'textarea';
				break;
			case 'INPUT':
				// Check for special cases using the map
				inputType =
					Object.entries(specialCaseMap).find(([selector]) =>
						input.closest(selector)
					)?.[1] || input.type;
				break;
			default:
				inputType = input.type;
		}

		// Assign type-specific class
		if (inputType === 'checkbox') {
			const checkboxInputs = formRow.querySelectorAll('input[type="checkbox"]');
			if (checkboxInputs.length > 1) {
				formRow.classList.add('checkboxes-row');
			} else {
				formRow.classList.add('checkbox-row');
			}

			if (getFieldIdentifier(input) === 'product-s-reviewed-select-all-that-apply') {
				console.log("THIS SHOULD BE 'checkboxes' ", checkboxInputs.length);
			}
		} else {
			const typeClass = typeToClassMap[inputType];
			if (typeClass) {
				formRow.classList.add(typeClass);
			}
		}

		// Add field identifier class
		const fieldId = getFieldIdentifier(input);

		if (fieldId) {
			formRow.classList.add(`name-${fieldId}`);
		}

		const fieldLabel = formRow.querySelector('label.mktoLabel');

		if (fieldLabel.textContent === '*') {
			fieldLabel.classList.add('no-label-field');
		}

		processedRows.add(formRow);
	});
}
class MarketoOverrides {
	constructor() {
		this.munchkinId = '';
		this.scriptURL = '';
		this.baseURL = '';

		this.loadedFormIds = [];
		this.initSuccess = false;
		this.marketoScriptLoaded = false;

		this.emitter = new Emitter();
	}

	init(munchkinId, scriptURL, baseURL) {
		if (!munchkinId || !scriptURL || !baseURL) {
			return;
		}

		this.munchkinId = munchkinId;
		this.scriptURL = scriptURL;
		this.baseURL = baseURL;
		this.loadForms();
	}

	async loadMarketoScript() {
		// check if the marketo script has already been loaded
		if (typeof MktoForms2 !== 'undefined') {
			return;
		}

		try {
			await loadFormsScript(this.scriptURL);
		} catch {
			throw new Error(`unable to load marketo script: ${this.scriptURL}`);
		}

		if (typeof MktoForms2 === 'undefined') {
			throw new Error('Marketo script has not been loaded');
		}

		MktoForms2.whenReady((form) => {
			// console.log(form);
			assignWidthClasses(form.getFormElem()[0]);
			removeInlineFormStyling(form.getFormElem()[0]);
			removeAddedCSSlinks();
			resizeCheckboxRows(form.getFormElem()[0]);
			customStyleAttributes();

			// Ensure full-width logic runs after all other form logic
			MarketoOverrides.updateMarketoFormFullWidthClasses();
		});
	}

	async loadForms() {
		const formEls = Array.from(document.querySelectorAll('[id^="mktoForm_"]'));

		if (formEls.length) {
			await this.loadMarketoScript();
		}

		// Create a new array to store unique form elements
		const uniqueFormEls = [];

		// Create a set to keep track of duplicate IDs
		const idSet = new Set();

		formEls.forEach((formEl) => {
			const { id } = formEl;

			// Check if the ID is already present in the set
			if (!idSet.has(id)) {
				// If not present, add the form element to the uniqueFormEls array
				uniqueFormEls.push(formEl);

				// Add the ID to the set
				idSet.add(id);
			}
		});

		uniqueFormEls.forEach((formEl) => {
			// console.log(formEl);
			const idParts = formEl.getAttribute('id').split('_');

			if (!idParts[1]) {
				return;
			}

			const formId = parseInt(idParts[1], 10);
			const ignorePrevLoad = parseInt(formEl.getAttribute('data-ignore-previous-load'), 10);

			// skip if previously loaded
			if (this.loadedFormIds.indexOf(formId) !== -1 && !ignorePrevLoad) {
				return;
			}

			MktoForms2.loadForm(this.baseURL, this.munchkinId, formId, (form) => {
				form.onSuccess((formObj) => {
					this.emitter.emit('submit-success', { formObj });
				});

				this.loadedFormIds.push(formId);

				this.emitter.emit('form-loaded', { formId });

				const formStyles = jQuery('form style, style:contains("#mktoStyleLoaded")');
				jQuery(formStyles).remove();
				const loadedForms = Array.from(
					document.querySelectorAll('[id^="' + formEl.id + '"]')
				);
				loadedForms.forEach((loadedForm) => {
					jQuery(loadedForm).removeAttr('id');
				});
			});
		});
	}

	static updateMarketoFormFullWidthClasses() {
		const forms = document.querySelectorAll('form.mktoForm');
		forms.forEach((form) => {
			const parent = form.parentElement;
			if (!parent) return;
			const formRect = form.getBoundingClientRect();
			const formWidth = formRect.width;
			if (formWidth <= 350) {
				form.classList.add('force-full-width');
			} else {
				form.classList.remove('force-full-width');
			}
		});
	}
}

const instance = new MarketoOverrides();

// Ensure the full-width logic runs after all other form logic on DOM ready and window resize
if (typeof window !== 'undefined') {
	document.addEventListener('DOMContentLoaded', () => {
		setTimeout(() => {
			MarketoOverrides.updateMarketoFormFullWidthClasses();
		}, 0);
	});
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			MarketoOverrides.updateMarketoFormFullWidthClasses();
		}, 150);
	});
}

export default instance;
